import React from 'react';
import ReactDOM from 'react-dom';

import {SideCart} from './components';

export default (function () {
  const rootUrl = window.theme.locale && !window.theme.locale.primary ? window.theme.locale.rootUrl : '';
  const freeShippingBarSettings = {
    enabled: window.theme.freeShippingBar && window.theme.freeShippingBar.enabled,
    remainingTemplate: window.theme.strings.freeShippingBar.remaining,
    reachedTemplate: window.theme.strings.freeShippingBar.reached,
    serviceOne: window.theme.freeShippingBar.serviceOne,
    serviceTwo:
      window.theme.freeShippingBar && window.theme.freeShippingBar.serviceTwo
        ? window.theme.freeShippingBar.serviceTwo
        : null,
    thresholdOne: Number(window.theme.freeShippingBar.thresholdOne) * 100,
    thresholdTwo:
      window.theme.freeShippingBar && window.theme.freeShippingBar.thresholdTwo
        ? Number(window.theme.freeShippingBar.thresholdTwo) * 100
        : null,
  };

  const cartWrapper = document.querySelector('#react-side-cart');
  if (cartWrapper) {
    ReactDOM.render(
      <SideCart rootUrl={rootUrl} freeShippingBarSettings={freeShippingBarSettings} isCartPage={false} />,
      cartWrapper
    );
  }

  const cartPageWrapper = document.querySelector('#react-cart-page');
  if (cartPageWrapper && window.theme.locale.pageType === 'cart') {
    ReactDOM.render(
      <SideCart rootUrl={rootUrl} freeShippingBarSettings={freeShippingBarSettings} isCartPage />,
      cartPageWrapper
    );
  }
})();
